// One question on a throwaway connection, for everything a client needs before it has a room: the
// catalogue that fills the entry form, the history, and every account command.
//
// The server answers an unhappy command with an error message rather than with the reply that was
// expected, so an error is a rejection here and not a timeout: somebody typing the wrong password
// must be told at once, not in eight seconds.

import { Connection } from './connection.js';
import { Protocol, ServerProtocol } from '../generated/protocol.js';

export function ask(serverUrl, request, replyTags, timeoutMillis = 8000) {
  const accepted = [replyTags].flat();
  return new Promise((resolve, reject) => {
    let settled = false;
    const finish = (fn, value) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      connection.close();
      fn(value);
    };
    const timer = setTimeout(
      () => finish(reject, new Error('il server non ha risposto in tempo')),
      timeoutMillis,
    );
    let connection;
    try {
      connection = new Connection(serverUrl, {
        onOpen: () => connection.send(request),
        onMessage: (message) => {
          const tag = message[Protocol.JSONTagID];
          if (accepted.includes(tag)) {
            finish(resolve, message);
          } else if (tag === ServerProtocol.TagError) {
            finish(
              reject,
              new Error(message[ServerProtocol.MessageID] ?? 'il server ha rifiutato la richiesta'),
            );
          }
        },
        onDisconnected: () => finish(reject, new Error('connessione al server non riuscita')),
      });
    } catch (error) {
      finish(reject, error);
    }
  });
}
